import React from 'react';
import config from 'config';
import { useSelector } from 'react-redux';
import { useFeatureFlag } from '@mulesoft/exchange-react-hooks';
import SidebarProductHeading from '@mulesoft/anypoint-components/raw/platform-components/SidebarProductHeading';
import { selectors as sessionSelectors } from '@mulesoft/exchange-ui-portals-store/lib/domains/session';
import classNames from 'classnames';
import { GLOBAL_NAVBAR_SUPPORT_ENABLED } from '../../domains/featureFlags/keys';
import styles from './ProductHeading.css';

const ProductHeading = ({ isSidebarItem }: { isSidebarItem?: boolean }) => {
  const isGlobalNavbarEnabled = useFeatureFlag(GLOBAL_NAVBAR_SUPPORT_ENABLED);
  const isMarketingSite = useSelector(sessionSelectors.isMarketingSite);
  const isPublicPortal = useSelector(sessionSelectors.isPublicPortal);

  if (!isGlobalNavbarEnabled || isMarketingSite || isPublicPortal) {
    return null;
  }

  return (
    <div
      className={classNames(styles.container, {
        [styles.sidebarItem]: isSidebarItem
      })}
    >
      <SidebarProductHeading
        href={config.contextPath}
        icon="exchange-logo-filled"
        label="Exchange"
      />
    </div>
  );
};

ProductHeading.defaultProps = {
  isSidebarItem: false
};

export default ProductHeading;
